import useScrollAnimation from '../../../hooks/useScrollAnimation';
import { Helmet } from 'react-helmet-async';

import speakerDefaultImg from '../../../utils/images/speaker-default.png';
import speaker1Img from '../../../utils/images/speaker_femi.png';
import speaker2Img from '../../../utils/images/speaker_prof.png';
import speaker3Img from '../../../utils/images/godwin.png';
import speakerDickson from '../../../utils/images/SpeakerDickson.png';

import './speakerPage.css';

const SpeakersPage = () => {
  useScrollAnimation();

  return (
    <main className='speakers-page page-width px-3 overflow-hidden'>
        <Helmet>
            <title>Speakers - Cosmos Conference 2024</title>
            <meta name="description" content="Meet the esteemed speakers of Cosmos Conference 2024." />
            <link rel="canonical" href="https://cosmosconference.org/speakers" />
        </Helmet>


        <section className="speaker_hero-section pt-5 mt-5 py-md-5">
            <h1 className='py-5'>MEET OUR SPEAKERS & PANELIST</h1>
        </section>  

        <section className="speakers  my-2 my-md-5 py-0 py-md-5">
            <h2 className="text-center text-uppercase mt-5 py-2 py-md-5">Meet our speakers</h2>    

            <div className="speakers-profile row">
                <div className="col-md-4 col-sm-12 mb-5 js-scroll slide-right">
                    <div className="profile-details">
                        <img src={speaker1Img} alt="profile pic" className='' />
                        <div className="profile-info">
                            <h3 className='custom-thunder'>APST. FEMI LAZARUS</h3>
                            <p className='custom-cosmos'>Founder of Light Nation</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-12 mb-5 js-scroll slide-left">
                    <div className="profile-details">
                        <img src={speaker2Img} alt="profile pic" className='' />
                        <div className="profile-info">
                        <h3 className='custom-thunder'>prof. conrad omonhinmin</h3>
                        <p className='custom-cosmos'>Director CUCRID Covenant University</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-12 mb-5 js-scroll fade-in-bottom">
                    <div className="profile-details">
                        <img src={speaker3Img} alt="profile pic" className='pt-5' />
                        <div className="profile-info">
                            <h3 className='custom-thunder'>GODWIN AIGBOVIODE OMAGE</h3>
                            <p className='custom-cosmos'>Founder, Co-Net technologies Ltd</p>
                        </div>
                    </div>
                </div>

                {/* <div className="col-md-4 col-sm-12 mb-5 js-scroll slide-right">
                    <div className="profile-details">
                        <img src={speaker2Img} alt="profile pic" className='pt-4' />
                        <div className="profile-info">
                            <h3 className='custom-thunder'>APST. FEMI LAZARUS</h3>
                            <p className='custom-cosmos'>Founder, The Light Nation</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-12 mb-5 js-scroll fade-in-bottom">
                    <div className="profile-details">
                        <img src={speakerDefaultImg} alt="profile pic" className='pt-4' />
                        <div className="profile-info">
                            <h3 className='custom-thunder my-1'>Coming Soon</h3>
                            <p className='custom-cosmos'>Speaker, Founder MyGrowthFund</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-12 mb-5 js-scroll slide-left">
                    <div className="profile-details">
                        <img src={speaker1Img} alt="profile pic" className='pt-4' />
                        <div className="profile-info">
                        <h3 className='custom-thunder'>prof. conrad omonhinmin</h3>
                        <p className='custom-cosmos'>Director CUCRID Covenant University</p>
                        </div>
                    </div>
                </div> */}

            </div>  

            <div className="row justify-content-center">
                <div className="col-md-4 col-sm-12 mb-5 js-scroll slide-right">
                    <div className="profile-details">
                        <img src={speakerDickson} alt="profile pic" className='pt-4' />
                        <div className="profile-info">
                            <h3 className='custom-thunder'>Hon. Fineboy D. Ebegbare</h3>
                            <p className='custom-cosmos'>Political Technocrat</p>
                        </div>
                    </div>
                </div>
                {/* <div className="col-md-4 col-sm-12 mb-5 js-scroll fade-in-bottom">
                    <div className="profile-details">
                        <img src={speakerDefaultImg} alt="profile pic" className='pt-4' />
                        <div className="profile-info">
                            <h3 className='custom-thunder my-1'>Coming Soon</h3>
                            <p className='custom-cosmos'>Speaker, Founder MyGrowthFund</p>
                        </div>
                    </div>
                </div> */}
            </div> 
            
        </section> 
            
        {/* <section className="panelist my-2 my-md-5 py-0">
            <h2 className="text-center text-uppercase pt-md-5 pt-2 pb-4">Meet our panelists</h2>    

            <div className="speakers-profile row">
                <div className="col-md-4 col-sm-12 mb-5 js-scroll slide-left">
                    <div className="profile-details">
                        <img src={speaker1Img} alt="profile pic" className='pt-4' />
                        <div className="profile-info">
                            <h3 className='custom-thunder'>Vusi Thembekwayo</h3>
                            <p className='custom-cosmos'>Speaker, Founder MyGrowthFund</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-12 mb-5 js-scroll fade-in-bottom">
                    <div className="profile-details">
                        <img src={speaker2Img} alt="profile pic" className='pt-4' />
                        <div className="profile-info">
                            <h3 className='custom-thunder'>APST. FEMI LAZARUS</h3>
                            <p className='custom-cosmos'>Founder, The Light Nation</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-12 mb-5 js-scroll slide-right">
                    <div className="profile-details">
                        <img src={speaker1Img} alt="profile pic" className='pt-4' />
                        <div className="profile-info">
                            <h3 className='custom-thunder'>Vusi Thembekwayo</h3>
                            <p className='custom-cosmos'>Speaker, Founder MyGrowthFund</p>
                        </div>
                    </div>
                </div>

                <div className="col-md-4 col-sm-12 mb-5 js-scroll slide-left">
                    <div className="profile-details">
                        <img src={speaker1Img} alt="profile pic" className='pt-4' />
                        <div className="profile-info">
                            <h3 className='custom-thunder'>Vusi Thembekwayo</h3>
                            <p className='custom-cosmos'>Speaker, Founder MyGrowthFund</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-12 mb-5 js-scroll fade-in-bottom">
                    <div className="profile-details">
                        <img src={speaker2Img} alt="profile pic" className='pt-4' />
                        <div className="profile-info">
                            <h3 className='custom-thunder'>APST. FEMI LAZARUS</h3>
                            <p className='custom-cosmos'>Founder, The Light Nation</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-12 mb-5 js-scroll slide-right">
                    <div className="profile-details">
                        <img src={speaker1Img} alt="profile pic" className='pt-4' />
                        <div className="profile-info">
                            <h3 className='custom-thunder'>Vusi Thembekwayo</h3>
                            <p className='custom-cosmos'>Speaker, Founder MyGrowthFund</p>
                        </div>
                    </div>
                </div>

                <div className="col-md-4 col-sm-12 mb-5 js-scroll slide-left">
                    <div className="profile-details">
                        <img src={speaker1Img} alt="profile pic" className='pt-4' />
                        <div className="profile-info">
                            <h3 className='custom-thunder'>Vusi Thembekwayo</h3>
                            <p className='custom-cosmos'>Speaker, Founder MyGrowthFund</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-12 mb-5 js-scroll fade-in-bottom">
                    <div className="profile-details">
                        <img src={speaker2Img} alt="profile pic" className='pt-4' />
                        <div className="profile-info">
                            <h3 className='custom-thunder'>APST. FEMI LAZARUS</h3>
                            <p className='custom-cosmos'>Founder, The Light Nation</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-12 mb-5 js-scroll slide-right">
                    <div className="profile-details">
                        <img src={speaker1Img} alt="profile pic" className='pt-4' />
                        <div className="profile-info">
                            <h3 className='custom-thunder'>Vusi Thembekwayo</h3>
                            <p className='custom-cosmos'>Speaker, Founder MyGrowthFund</p>
                        </div>
                    </div>
                </div>
            </div>    
        </section>  */}

    </main>
  )
}

export default SpeakersPage